import { Stack } from '@mui/material';
import type { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from '~/components/organisms/Header';
import { CSPHelmet } from '~/components/utilities/CSPHelmet';

export const AuthenticatedLayout: FC = () => {
  return (
    <>
      <CSPHelmet />
      <Stack minHeight="100dvh">
        <Header />
        <Stack component="main" mb="auto">
          <Outlet />
        </Stack>
      </Stack>
    </>
  );
};
